import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Carousel from "react-bootstrap/Carousel";
import Accordion from "react-bootstrap/Accordion";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Appqr from '../../components/Appqr';
import "./RelationshipCoachingWorkshopsPage.css";

const images = [
  "assests/images/pairing-1.jpg",
  "assests/images/pairing-2.jpg",
  "assests/images/pairing-1.jpg",
];

const RelationshipCoachingWorkshopsPage = () => {

  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
      });
    document.title = `Relationship Coaching | Your Friend My Friend`;
    document.getElementById('bodywrap').className='speedys';
  },[]);  

  return (
    <>
      <Header />

      <div className="hello-worldss d-flex justify-content-center align-items-center">
        {/* Desktop Image */}
        <img
          src={process.env.REACT_APP_BASE_URL + 'assests/images/coaching-d.jpg'}
          alt="QR Code"
          className="img-fluid d-none d-md-block"
        />

        {/* Mobile Image */}
        <img
          src={process.env.REACT_APP_BASE_URL + 'assests/images/coaching-m.jpg'}
          alt="QR Code"
          className="img-fluid d-block d-md-none"
        />
      </div>

      <div className="container-fluid ireland">
        <div className="row g-4">
          <div className="col-md-6 ire-left">
            <p>Relationship Coaching & Workshops </p>
            <h2>
              Build Confidence, Improve Connections 
            </h2>
          </div>

          <div className="col-md-6 ire-right">
            <p>
              Our Relationship Coaching & Workshops are designed to help singles navigate dating with more confidence, clarity, and success. Whether you're looking to improve your communication skills, understand what you're looking for in a partner, or simply feel more comfortable putting yourself out there, these sessions provide practical tools and expert insights to help you build stronger connections.             </p>
            <div className="arrive">
              <Link
                to="/upcoming-events"
                className="btn bros-bu text-decoration-none"
              >
                BROWSE EVENTS
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid owned newyfty">
        <div className="get-miss">
          <div className="row d-flex align-items-strech g-4">
            {/* Text Section */}
            <div className="col-md-4 od-2 d-flex">
              <div className="get-app d-flex flex-column flex-grow-1 horiz">
                <div className="tired">
                  <h2>COACHING</h2>
                  <h4>Meet Annie Lavin</h4>
                </div>
                <div className="tired-2 mt-auto">
                  <p className="mb-0 text-start">
                    YFMF partners with Annie Lavin for our relationship coaching sessions. Annie is an accredited psychotherapist and master coach who blends therapeutic insight with practical coaching strategies. Her holistic approach helps individuals gain clarity, break through personal barriers, and take meaningful action toward lasting relationship success.
                  </p>
                </div>
              </div>
            </div>

            {/* Image Section */}
            <div className="col-md-8 od-1 d-flex">
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/annie-img.png'}
                alt="Event Promo"
                className="img-fluid eve-img"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="container-fluid expand new-expa">
        <div className="row align-items-strech d-flex">
          {/* Left Side Content */}
          <div className="col-md-6 d-flex flex-column justify-content-between">
            <div className="tired">
              <h2>HOW IT WORKS</h2>
              <h4>What to expect </h4>
              <p>These workshops are designed to give you the tools to succeed in dating and relationships. Whether you're just getting back out there or looking to refine your approach, invest in yourself and start making meaningful connections.</p>
            </div>
            <div className="tired-2">
              <Link
                to="/upcoming-events"
                className="brow-bu text-decoration-none d-none d-md-inline-block"
              >
                BROWSE EVENTS
              </Link>
            </div>
          </div>

          {/* Right Side Features */}
          <div className="col-md-6 d-flex flex-column">
            <div className="d-flex flex-grow-1 gap-3 locat">
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/boosti-1.png'}
                alt="Previous"
                className="img-fluid new"
              />
              <div>
                <h5>Confidence-Boosting Strategies</h5>
                <p>Learn how to approach dating with self-assurance and ease.</p>
              </div>
            </div>
            <div className="d-flex flex-grow-1 gap-3 locat">
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/boosti-2.png'}
                alt="Previous"
                className="img-fluid new"
              />
              <div>
                <h5>Interactive & Practical Sessions</h5>
                <p>
                  Hands-on activities, Q&As, and real-world exercises to help you apply what you learn.  
                </p>
              </div>
            </div>
            <div className="d-flex flex-grow-1 gap-3 locat">
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/boosti-3.png'}
                alt="Previous"
                className="img-fluid new"
              />
              <div>
                <h5>Meet Like-Minded Singles</h5>
                <p>
                  Engage in discussions and exercises with others looking to improve their dating experiences. 
                </p>
              </div>
            </div>
            <div className="d-flex flex-grow-1 gap-3 locat locats">
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/boosti-4.png'}
                alt="Previous"
                className="img-fluid new"
              />
              <div>
                <h5>Take Control of Your Dating Life </h5>
                <p>
                  No more guesswork—learn how to navigate modern dating with intention and clarity. 
                </p>
              </div>
            </div>
          </div>

          <div className="d-flex d-md-none order-4 tired-2 mt-3 text-center">
            <Link
              to="/contact"
              className="brow-bu text-decoration-none w-100"
            >
              Get in touch
            </Link>
          </div>
        </div>
      </div>

      <div className="container-fluid real-connection new-real sparks">
        <div className="row">
          {/* Left Side Text */}
          <div className="col-md-5 d-flex flex-column justify-content-between">
            <div className="slidees ols">
              <h6>YFMF</h6>
              <h2>Lorem ipsum</h2>
            </div>
            {/* Navigation Arrows */}
            <div className="d-none d-md-flex justify-content-start">
              <button
                className="btn"
                onClick={() =>
                  setIndex(index === 0 ? images.length - 1 : index - 1)
                }
              >
                <div className="arrow-container">
                  <img
                    src={process.env.REACT_APP_BASE_URL + 'assests/images/carousel-left.png'}
                    className="img-fluid arrow-image arrow-image-1"
                    alt="Previous"
                  />
                  <img
                    src={process.env.REACT_APP_BASE_URL + 'assests/images/carousel-left-hover.png'}
                    className="img-fluid arrow-image arrow-image-2"
                    alt="Previous Hover"
                  />
                </div>
              </button>
              <button
                className="btn"
                onClick={() =>
                  setIndex(index === images.length - 1 ? 0 : index + 1)
                }
              >
                <div className="arrow-container">
                  <img
                    src={process.env.REACT_APP_BASE_URL + 'assests/images/carousel-right.png'}
                    className="img-fluid arrow-image arrow-image-1"
                    alt="Next"
                  />
                  <img
                    src={process.env.REACT_APP_BASE_URL + 'assests/images/carousel-right-hover.png'}
                    className="img-fluid arrow-image arrow-image-2"
                    alt="Next Hover"
                  />
                </div>
              </button>
            </div>
          </div>

          <div className="col-md-1"></div>

          {/* Bootstrap Carousel with 1.5 Images Visible */}
          <div className="col-md-6">
            <Carousel
              activeIndex={index}
              onSelect={handleSelect}
              indicators={false}
              controls={false}
              interval={5000}
              wrap={true}
              slide={true}
              className="custom-carousel"
            >
              {images.concat(images[0]).map((img, i) => (
                <Carousel.Item key={i}>
                  <div className="carousel-images">
                    <img
                      src={process.env.REACT_APP_BASE_URL + img}
                      className="img-fluid main-img"
                      alt={`Slide ${i}`}
                    />
                    {images[(i + 1) % images.length] && (
                      <img
                        src={process.env.REACT_APP_BASE_URL + images[(i + 1) % images.length]}
                        className="img-fluid extra-img"
                        alt={`Slide ${(i + 1) % images.length}`}
                      />
                    )}
                  </div>
                </Carousel.Item>
              ))}
            </Carousel>
          </div>

          <div className="col-12 d-flex d-md-none justify-content-between mt-3 p-0">
            <button
              className="btn"
              onClick={() =>
                setIndex(index === 0 ? images.length - 1 : index - 1)
              }
            >
              <div className="arrow-container">
                <img
                  src={process.env.REACT_APP_BASE_URL + 'assests/images/carousel-left.png'}
                  className="img-fluid arrow-image arrow-image-1"
                  alt="Previous"
                />
                <img
                  src={process.env.REACT_APP_BASE_URL + 'assests/images/carousel-left-hover.png'}
                  className="img-fluid arrow-image arrow-image-2"
                  alt="Previous Hover"
                />
              </div>
            </button>
            <button
              className="btn"
              onClick={() =>
                setIndex(index === images.length - 1 ? 0 : index + 1)
              }
            >
              <div className="arrow-container">
                <img
                  src={process.env.REACT_APP_BASE_URL + 'assests/images/carousel-right.png'}
                  className="img-fluid arrow-image arrow-image-1"
                  alt="Next"
                />
                <img
                  src={process.env.REACT_APP_BASE_URL + 'assests/images/carousel-right-hover.png'}
                  className="img-fluid arrow-image arrow-image-2"
                  alt="Next Hover"
                />
              </div>
            </button>
          </div>
        </div>
      </div>

      <div className="accors accordi good">
        <div className="row">
          <div className="col-md-6">
            <h2>FAQ</h2>
            <h3>Good to know</h3>
          </div>
          <div className="col-md-6">
            <Accordion>
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  What is a Relationship Coaching Workshop?
                </Accordion.Header>
                <Accordion.Body>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  Who is the workshop for?
                </Accordion.Header>
                <Accordion.Body>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  Do I need to be actively dating to attend?
                </Accordion.Header>
                <Accordion.Body>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="3">
                <Accordion.Header>Who leads the workshop?</Accordion.Header>
                <Accordion.Body>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="4">
                <Accordion.Header>What topics will be covered?</Accordion.Header>
                <Accordion.Body>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="5">
                <Accordion.Header>How interactive is the workshop?</Accordion.Header>
                <Accordion.Body>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="6">
                <Accordion.Header>How long is the workshop?</Accordion.Header>
                <Accordion.Body>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="7">
                <Accordion.Header>What is included in the ticket price?</Accordion.Header>
                <Accordion.Body>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="8">
                <Accordion.Header>What should I bring?</Accordion.Header>
                <Accordion.Body>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="9">
                <Accordion.Header>Can I attend alone?</Accordion.Header>
                <Accordion.Body>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="10">
                <Accordion.Header>How do I sign up?</Accordion.Header>
                <Accordion.Body>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="11" className="hololast">
                <Accordion.Header>
                Is this a dating event?
                </Accordion.Header>
                <Accordion.Body>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>
      </div>
      <Appqr />
      <Footer />
    </>
  );
};

export default RelationshipCoachingWorkshopsPage;